module.exports = "/_next/static/images/logo-e2b3693ada54243d1adfc65275415525.png";